import C5BaseDAO from "./C5BaseDAO";
import C5PagamentoModel from "../../model/C5PagamentoModel";
import C5MeioPagamentoModel from "../../model/C5MeioPagamentoModel";
import LojaModel from "../../model/LojaModel";
import CarrinhoModel from "../../model/CarrinhoModel";
import C5FreteModel from "../../model/C5FreteModel";
import UsuarioModel from "../../model/UsuarioModel";

class C5PagamentoDAO extends C5BaseDAO {
  private static instance: C5PagamentoDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): C5PagamentoDAO {
    if (!C5PagamentoDAO.instance) {
      C5PagamentoDAO.instance = new C5PagamentoDAO();
    }
    return C5PagamentoDAO.instance;
  }

  public async pagar(pagamento: C5PagamentoModel): Promise<any> {
    return this.post("REQ_C5_PGTO", `${this.endpoint}/Sale`, pagamento);
  }

  public async getCartaoBandeira(tipo: string, valor: string): Promise<any> {
    const body: any = {
      CardType: tipo,
      CardNumber: valor,
    };
    return this.post(
      "REQ_C5_BANDEIRA_CARTAO",
      `${this.endpoint}/CardIdentifier`,
      body
    ).catch((r: any) => {
      throw new Error(r.response.data.ExceptionMessage);
    });
  }

  public async getMeiosPagamento(): Promise<C5MeioPagamentoModel[]> {
    return this.get("REQ_PGTO_MEIO_PAGAMENTO", `${this.endpoint}/Sale`).then(
      (r: any) => {
        let arrPgtos: C5MeioPagamentoModel[] = [];
        const items: C5MeioPagamentoModel[][] | null = r.data
          .map((i: any) => C5MeioPagamentoModel.toModel(i))
          .filter((i: any) => i !== null);
        if (items) {
          for (const item of items) {
            arrPgtos = arrPgtos.concat(item);
          }
        }
        return arrPgtos;
      }
    );
  }

  public async getFrete(
    cep: string,
    carrinho: CarrinhoModel
  ): Promise<C5FreteModel[]> {
    const endpoint: string = `${this.endpoint}/Freight?ZipCode=${cep}&UIDBasket=${carrinho.carrinhoId}`;
    return this.get(`REQ_FRETE_LOJA_${cep}`, endpoint).then((r: any) => {
      let arrPgtos: C5FreteModel[] = [];
      const items: C5FreteModel[][] | null = r.data
        .map((i: any) => C5FreteModel.toModel(i))
        .filter((i: any) => i !== null);
      if (items) {
        for (const item of items) {
          arrPgtos = arrPgtos.concat(item);
        }
      }
      return arrPgtos;
    });
  }

  public async postFrete(
    loja: LojaModel,
    freteTipoId: number,
    carrinho: CarrinhoModel,
    usuario: UsuarioModel
  ): Promise<any> {
    return this.post("REQ_C5_FRETE_POST", `${this.endpoint}/Freight`, {
      ZipCode: loja.cepInicio,
      FreightTypeID: +freteTipoId,
      UIDBasket: carrinho.carrinhoId,
      StoreID: +loja.lojaId,
      ClientID: +usuario.clienteId,
    });
  }
}

export default C5PagamentoDAO;
